// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input {
  padding: 16px;
  border-radius: 8px;
  background: #FFFFFF;
  border: 1px solid transparent;
  outline: unset;
}

.input:focus {
  border-color: var(--red);
}
`, "",{"version":3,"sources":["webpack://./src/components/input/Input.scss","webpack://./src/components/input/Input.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;ACChB;;ADNA;EAQI,wBAAwB;ACE5B","sourcesContent":[".input {\n  padding: 16px;\n  border-radius: 8px;\n  background: #FFFFFF;\n  border: 1px solid transparent;\n  outline: unset;\n\n  &:focus {\n    border-color: var(--red);\n  }\n}",".input {\n  padding: 16px;\n  border-radius: 8px;\n  background: #FFFFFF;\n  border: 1px solid transparent;\n  outline: unset;\n}\n\n.input:focus {\n  border-color: var(--red);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
